export const formatter = {
	frequencyOfEarning: {
		eachEvent: "Una vez por evento",
		everytime: "Siempre",
		oncePerMonth: "Una vez por mes",
		oncePerWeek: "Una vez por semana",
	},
	promotionEarning: {
		everybody: {
			name: "Todos los clientes",
			description: "Para promociones que no exigen ninguna condición de uso",
		},
		minimumRechargeValue: {
			name: "Valor mínimo de recarga",
			description: "Para promociones que exigen una recarga mínima del cliente.",
		},
		gender: {
			name: "Género",
			description: "Para promociones exclusivas para mujeres, hombres u otros.",
		},
		birthdayPerson: {
			name: "Cumpleaños",
			description: "Para promociones para cumpleañeros del mes, semana o día.",
		},
		checkinTime: {
			name: "Horario de llegada",
			description: "Para promociones que exigen un horario de llegada específico.",
		},
		minimumValueConsumed: {
			name: "Valor mínimo consumido",
			description:
				"Para promociones que exigen que el usuario consuma un valor mínimo para tener derecho a la promoción.",
		},
		ppuUsage: {
			name: "Uso de PPU",
			description: "Para promociones de ventas hechas exclusivamente por la App.",
		},
		productsConsumed: {
			name: "Compre y Gane",
			description:
				"Para promociones en las que el cliente tiene derecho a promoción al comprar algún producto o categoría de productos.",
		},
		guestList: {
			name: "Lista de invitados",
		},
		maximumValueConsumed: {
			name: "Valor máximo consumido",
		},
		minimumPlaceFrequency: {
			name: "Frecuencia mínima del local",
		},
		maximumPlaceFrequency: {
			name: "Frecuencia máxima en el local",
		},
		productsConsumedQuantity: {
			name: "Cantidad de productos consumidos",
		},
	},
	promotionUsage: {
		period: {
			name: "Horario",
			description:
				"Defina un rango de horario en el que el cliente puede utilizar la promoción",
		},
		secondsToExpire: {
			name: "Expiración post-ganancia",
			description:
				"Defina cuánto tiempo tiene el cliente para aprovechar la promoción a la que tiene derecho",
		},
		weekDays: {
			name: "Días de la semana",
			description: "Defina qué días de la semana el cliente puede utilizar la promoción",
		},
	},
	convertUsageConditions: {
		empty: "No posee",
		at: "hasta",
		days: "días",
	},
	convertGoals: {
		empty: "No posee",
		everybody: "Su promoción no exige ninguna meta",
		checkinTime: "Horario de llegada",
	},
};
